// Story 8.10 (ADO-2019), DV-34: "Waiting orders" (the 8.10 Figma exports, "HHT · Orders
// waiting · 2"): one row per waiting order, oldest first: the date the file was received
// (DV-38, the viewer's zone), a lines-and-cases pill, an "N need(s) attention" pill when any
// line does, and "Review" to that order's review. The frames' source line ("Handheld scan ·
// FTP") is left out (DV-8). At phone width each row stacks and "Review" goes full width.
import { Link } from 'react-router';
import type { HhtWaitingOrder } from '../../api/hht-orders.client';
import { formatWeekdayDateTimeWithYear } from '../../shared/datetime';
import { HhtPill } from './HhtPill';
import { linesAndCases, needsAttentionLabel } from './hhtFormat';
import { hhtOrderPath } from './hhtRoutes';
import linkButton from '../Cart/LinkButton.module.css';
import styles from './HhtOrders.module.css';

/** Q5: "Waiting orders" with nothing waiting (the 8.10 Figma exports, "Q5 · No HHT orders
 *  waiting"): the "Added to carts" panel's card, its text centred. */
export function HhtNoOrdersWaiting() {
  return (
    <section
      className={`${styles.section} ${styles.waitingSection}`}
      aria-labelledby="hht-waiting-title"
    >
      <h2 id="hht-waiting-title" className={styles.sectionTitle}>
        Waiting orders
      </h2>
      <div className={`${styles.panel} ${styles.added} ${styles.empty}`}>
        <p className={styles.emptyTitle}>No HHT orders waiting</p>
        <p className={styles.emptyText}>
          Orders you send from your handheld appear here, ready to review and add to your carts.
        </p>
      </div>
    </section>
  );
}

export function HhtWaitingList({ waiting }: { readonly waiting: readonly HhtWaitingOrder[] }) {
  return (
    <section
      className={`${styles.section} ${styles.waitingSection}`}
      aria-labelledby="hht-waiting-title"
    >
      <h2 id="hht-waiting-title" className={styles.sectionTitle}>
        Waiting orders
      </h2>
      <ul className={`${styles.panel} ${styles.waitingList}`}>
        {waiting.map((order) => {
          const received = formatWeekdayDateTimeWithYear(order.receivedAt);
          return (
            <li key={order.hhtOrderId} className={styles.waitingRow}>
              <time className={styles.waitingDate} dateTime={order.receivedAt}>
                {received}
              </time>
              <span className={styles.waitingPills}>
                <HhtPill tone="info">{linesAndCases(order.lineCount, order.caseCount)}</HhtPill>
                {order.attentionLineCount > 0 ? (
                  <HhtPill tone="warning">{needsAttentionLabel(order.attentionLineCount)}</HhtPill>
                ) : null}
              </span>
              <Link
                to={hhtOrderPath(order.hhtOrderId)}
                className={`${linkButton.linkButton} ${linkButton.secondary} ${styles.waitingReview}`}
                aria-label={`Review the order received ${received}`}
              >
                Review
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
